import React from 'react';

class TerrainLayer extends React.Component{
    constructor() {
        super();
        this.terrainLayerChecked = this.terrainLayerChecked.bind(this);
    }
    terrainLayerChecked(layers){
        window.main.OView.reloadTerrain(layers.ID);
    }
    render(){
        return(
            <div className="ts checkboxes">
                {
                    window.TERRAIN_LAYERS.map(
                    (layers,index)=>
                    index === 0 ?
                    <div className="ts radio checkbox" key={layers.TITLE}>
                        <input type="radio" name="terrainLayer" id={layers.TITLE} defaultChecked="checked" onClick={(e)=>this.terrainLayerChecked(layers)}></input>
                        <label htmlFor={layers.TITLE}>{layers.TITLE}</label>
                    </div> 
                    :
                    <div className="ts radio checkbox" key={layers.TITLE}>
                        <input type="radio" name="terrainLayer" id={layers.TITLE} onClick={(e)=>this.terrainLayerChecked(layers)}></input>
                        <label htmlFor={layers.TITLE}>{layers.TITLE}</label>
                    </div>
                    )
                }
            </div> 
        );
    }
}

export default TerrainLayer;